import React from 'react';
import styled from 'styled-components';

const CorePassLogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: #a0a0a0;
  font-weight: 500;
`;

const CorePassLogoSVG = styled.svg`
  height: 20px;
  width: auto;
`;

const CorePassLogo = ({ className }) => {
  return (
    <CorePassLogoContainer className={className}>
      <CorePassLogoSVG 
        version="1.0" 
        xmlns="http://www.w3.org/2000/svg"
        width="56.000000pt" 
        height="68.000000pt" 
        viewBox="0 0 56.000000 68.000000"
        preserveAspectRatio="xMidYMid meet"
      >
        <g transform="translate(0.000000,68.000000) scale(0.100000,-0.100000)"
           fill="#2563EB" stroke="none">
          <path d="M270 579 c-55 -7 -100 -28 -100 -46 0 -17 18 -17 71 3 107 38 227
          -16 199 -90 -13 -36 -42 -48 -99 -40 -77 10 -120 -22 -121 -90 0 -52 39 -96
          86 -96 43 0 64 9 64 27 0 12 -8 14 -36 10 -29 -5 -40 -2 -60 18 -29 29 -30 46
          -6 73 20 25 35 28 84 18 45 -10 100 14 117 50 25 55 7 119 -40 145 -31 16
          -109 25 -159 18z"/>
          <path d="M258 490 c-72 -22 -128 -99 -128 -176 1 -130 135 -218 253 -166 27
          12 47 28 47 36 0 20 -17 20 -50 1 -60 -35 -150 -8 -191 57 -28 46 -22 128 12
          164 39 42 76 56 137 52 63 -4 81 13 31 31 -36 13 -72 13 -111 1z"/>
          <path d="M74 438 c-23 -44 -28 -65 -28 -123 0 -59 5 -79 29 -124 32 -59 91
          -112 144 -130 19 -6 65 -11 104 -11 56 0 79 5 118 27 31 17 49 33 49 45 0 24
          -9 23 -66 -9 -39 -22 -61 -28 -109 -27 -182 2 -292 193 -200 349 30 52 30 55
          7 55 -12 0 -29 -19 -48 -52z"/>
        </g>
      </CorePassLogoSVG>
      <span>CorePass</span>
    </CorePassLogoContainer>
  );
};

export default CorePassLogo; 